import { render, staticRenderFns } from "./HodOnboardingPendingPage.vue?vue&type=template&id=acb0c664&scoped=true&"
import script from "./HodOnboardingPendingPage.vue?vue&type=script&lang=ts&"
export * from "./HodOnboardingPendingPage.vue?vue&type=script&lang=ts&"
import style0 from "./HodOnboardingPendingPage.vue?vue&type=style&index=0&id=acb0c664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb0c664",
  null
  
)

export default component.exports